import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// mui components
import {
    Paper,
    Divider,
    styled,
    Grid,
    Box,
    Button,
    Modal,
    Typography,
    TextField,
    Card,
    CardHeader,
    CardContent,
    Stack
} from "@mui/material";
import Autocomplete from '@mui/material/Autocomplete';
import MenuItem from '@mui/material/MenuItem';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'; // Added for visual cue
const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 800,
    bgcolor: 'background.paper'
};

const AddLineItem = ({ addLineItemVisible, onAddLineItemModalClose, formDataHandler,dispatchHandler,dispatchCountryCode, onAddLineItemClick, addLineItemData, editLineItemId, errors,handleBlur,handleHsCodeBlur,skuOnly,isShipmentCreationFlow }) => {
    const country_code = useSelector(state => state.countrystate.country);
    const filteredCountryData = country_code.data.filter(({ code }) => code );
    const onChangeCountry = id => {
        dispatchCountryCode(id)
    }
    const getSelectedCountry = (country_code) => {
        let filteredValue = { code: "", name: "" };
        filteredCountryData.map((key) => {
          if (key.code == country_code) {
            filteredValue = key;
          }
        });
         return filteredValue;
      };
    return (
        <>
            <Modal
                open={addLineItemVisible}
                onClose={onAddLineItemModalClose}
            >
                <Box sx={modalStyle}>
                    <Card sx={{ minWidth: 600 }} className="sc--cardhead--details">
                        <CardHeader title={(editLineItemId != "") ? "Update Line Item" : "New Line Item"} />
                        <Divider />
                        <CardContent>
                            <div className="sc--form--center" style={{ margin: '20px 0' }}>
                               <Autocomplete
                                    options={skuOnly}
                                    value={addLineItemData.sku || ''}
                                    freeSolo
                                    // onChange triggers when an item is SELECTED from the list
                                    onChange={(e, newValue) => {
                                        const syntheticEvent = {
                                            target: {
                                                name: 'sku',
                                                value: newValue || ''
                                            }
                                        };
                                        formDataHandler(syntheticEvent);
                                        dispatchHandler(syntheticEvent); // Auto-fill details on selection
                                    }}
                                    // onInputChange handles both manual TYPING and PASTE
                                    onInputChange={(e, newInputValue, reason) => {
                                        // reason === 'input' covers typing and pasting
                                        if (reason === 'input' || reason === 'clear') {
                                            const syntheticEvent = {
                                                target: {
                                                    name: 'sku',
                                                    value: newInputValue || ''
                                                }
                                            };
                                            formDataHandler(syntheticEvent);
                                            
                                            // Optional: If you want to trigger the lookup immediately on paste:
                                            if (newInputValue && newInputValue.length >= 1) {
                                                dispatchHandler(syntheticEvent);
                                            }
                                        }
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            id="standard-basic"
                                            label="SKU*"
                                            variant="standard"
                                            name="sku"
                                            error={errors.sku}
                                            helperText={errors.sku}
                                            style={{ width: "100%", margin: '8px' }}
                                        />
                                    )}
                                    style={{ width: "100%", margin: '8px' }}
                                />
                                <TextField id="standard-basic"
                                    label="Product Id*"
                                    variant="standard"
                                    name="product_id"
                                    value={addLineItemData.product_id}
                                    onChange={formDataHandler}
                                    error={errors.product_id}
                                    helperText={errors.product_id}
                                    style={{ width: "100%", margin: '8px' }}
                                />
                            </div>
                            <div className="sc--form--center" style={{ margin: '20px 0' }}>
                                <TextField id="standard-basic"
                                    label="Product Description*"
                                    variant="standard"
                                    name="product_desc"
                                    onBlur={handleBlur}
                                    value={addLineItemData.product_desc}
                                    onChange={formDataHandler}
                                    error={errors.product_desc}
                                    helperText={errors.product_desc}
                                    style={{ width: "100%", margin: '8px' }}
                                />
                                <TextField id="standard-basic"
                                    label="Product Url"
                                    variant="standard"
                                    name="product_url"
                                    value={addLineItemData.product_url}
                                    onChange={formDataHandler}
                                    error={errors.product_url}
                                    helperText={errors.product_url}
                                    style={{ width: "100%", margin: '8px' }}
                                />
                            </div>
                            <div className="sc--form--center" style={{ margin: '20px 0' }}>
                                <TextField id="standard-basic"
                                    label="Currency*"
                                    variant="standard"
                                    name="currency"
                                    value={addLineItemData.currency}
                                    onChange={formDataHandler}
                                    error={errors.currency}
                                    helperText={errors.currency}
                                    style={{ width: "100%", margin: '8px' }}
                                />
                                <TextField id="standard-basic"
                                    label="Unit Price*"
                                    variant="standard"
                                    name="product_price"
                                    value={addLineItemData.product_price}
                                    onBlur={handleBlur}
                                    onChange={formDataHandler}
                                    error={errors.product_price}
                                    helperText={errors.product_price}
                                    style={{ width: "100%", margin: '8px' }}
                                />
                            </div>
                            <div className="sc--form--center" style={{ margin: '20px 0' }}>
                                <TextField id="standard-basic"
                                    label="Quantity*"
                                    variant="standard"
                                    name="quantity"
                                    value={addLineItemData.quantity}
                                    onChange={formDataHandler}
                                    error={errors.quantity}
                                    helperText={errors.quantity}
                                    style={{ width: "100%", margin: '8px' }}
                                />
                                <Autocomplete
                                    className="help-text-error"
                                    disablePortal
                                    name="origin_country_code*"
                                    id="country-select-demo"
                                    sx={{ width: "100%", margin: '8px'}}
                                    options={filteredCountryData}
                                    autoHighlight
                                    loading={country_code && country_code.loading}
                                    getOptionLabel={(option) => option.name}
                                    value={getSelectedCountry(addLineItemData && addLineItemData.origin_country_code)}
                                    renderOption={(props, option) => (
                                    <MenuItem {...props} value={option.code} key={option.code}>
                                        {option.icon} {option.name}
                                    </MenuItem>
                                    )}
                                    onChange={(event, value) => {
                                    if (value !== null) {
                                        onChangeCountry(value.code);
                                    } else {
                                        onChangeCountry("");
                                    }
                                    }}
                                    renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Country of Origin*"
                                        variant="standard"
                                        error={errors.origin_country_code}
                                        helperText={errors.origin_country_code}
                                    />
                                    )}
                                />
                            </div>
                            <div style={{ display: 'flex', gap: '15px', marginBottom: '25px' }}>
                                <TextField 
                                    label="Hs Code*" 
                                    variant="standard" 
                                    name="hs_tariff_code" 
                                    value={addLineItemData.hs_tariff_code || ''} 
                                    onChange={formDataHandler} 
                                    onBlur={handleHsCodeBlur} 
                                    error={!!errors.hs_tariff_code}
                                    // --- DYNAMIC DIGIT COUNTER ---
                                    helperText={
                                        <Typography 
                                            variant="caption" 
                                            component="span" 
                                            sx={{ 
                                                color: addLineItemData.hs_tariff_code?.replace(/\./g, '').length === 10 
                                                    ? 'success.main' 
                                                    : (errors.hs_tariff_code ? 'error.main' : 'text.secondary') 
                                            }}
                                        >
                                            {errors.hs_tariff_code ? errors.hs_tariff_code : 
                                            `Digits: ${addLineItemData.hs_tariff_code?.replace(/\./g, '').length || 0} / 10 required`}
                                        </Typography>
                                    }
                                    fullWidth 
                                />
                                <TextField 
                                    label="Hs Country Code" 
                                    variant="standard" 
                                    name="hs_tariff_code_country" 
                                    value={addLineItemData.hs_tariff_code_country || ''} 
                                    onChange={formDataHandler} 
                                    fullWidth 
                                />
                            </div>
                            {isShipmentCreationFlow && (
                                <Box 
                                    sx={{ 
                                        bgcolor: '#fff9c4', // Light Yellow Background
                                        p: 1.5, 
                                        borderRadius: 1, 
                                        mb: 3, 
                                        borderLeft: '4px solid #fbc02d', // Darker Yellow Border
                                        boxShadow: '0px 1px 3px rgba(0,0,0,0.05)'
                                    }}
                                >
                                    <Stack direction="row" spacing={1} alignItems="center">
                                        <InfoOutlinedIcon sx={{ color: '#f9a825', fontSize: 20 }} />
                                        <Typography variant="caption" sx={{ color: '#574300', fontWeight: 600 }}>
                                            Note: Changes apply to this order only. Inventory and other orders will not be updated.
                                        </Typography>
                                    </Stack>
                                </Box>
                            )}
                            <div className="sc--form--center" style={{ marginTop: "15px" }}>
                                <Button
                                    variant="outlined"
                                    onClick={onAddLineItemClick}
                                    style={{ border: '1px solid rgba(0, 0, 0, 0.12)', margin: '0 15px' }}
                                >
                                    {(editLineItemId != "") ? "Update Item" : "Add Item"}
                                </Button>
                            </div>
                        </CardContent>
                    </Card>
                </Box>
            </Modal>
        </>
    )
}

export default AddLineItem;